<template>
	<div class="sim">
		<div class="sim-left">
			<div class="sim-left-top">
				<my-tree
					@selectClick="selectClick"
					@node-click="handleNodeClick"
					:selectButton="true"
					:treeData="treeData"
					:defaultProps="defaultProps"
					:selectText="selectbtnText"
					@pushTree="pushTree"
				></my-tree>
			</div>
			<!-- <div
        class="sim-left-footer"
      >
        <my-tree
          :treeData="grounpsTree"
          @node-click="handlegroupClcik"
          :defaultProps="grounpProps"
          @pushTree="pushTree"
          :tree-icon="'icon-guanliyuan1'"
        ></my-tree>
      </div>-->
		</div>
		<div class="sim-right" ref="sim_right">
			<div class="search_tableBox" v-if="isSelect == 1">
				<div class="search_tab">
					<el-radio-group v-model="selectNum" @change="clearData">
						<el-radio :label="1">根据号码</el-radio>
						<el-radio :label="2">根据ICCID号段</el-radio>
						<el-radio :label="3">根据SIM号段</el-radio>
					</el-radio-group>
				</div>
				<div class="search_text" v-if="selectNum === 1">
					<textarea placeholder="请粘贴ICCID或SIM卡号" v-model="simprops.simCards" />
				</div>
				<div class="search_sim" v-else-if="selectNum == 2">
					<input placeholder="ICCID号字段" class="filter-type-input" style="margin-left:10px" v-model="simprops.startIccid" />
					<span class="split-line"></span>
					<input placeholder="ICCID号字段" class="filter-type-input" v-model="simprops.endIccid" />
				</div>
				<div class="search_sim" v-else>
					<input placeholder="SIM号字段" class="filter-type-input" style="margin-left:10px" v-model="simprops.startSimCard" />
					<span class="split-line"></span>
					<input placeholder="SIM号字段" class="filter-type-input" v-model="simprops.endSimCard" />
				</div>
				<el-popover placement="bottom" width="420px" trigger="click">
					<div class="popover_col">
						<span class="popover_font">开卡日期</span>
						<el-date-picker v-model="pickTime.startOpenTime" type="date" class="date_picker" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
						<span class="split-line"></span>
						<el-date-picker v-model="pickTime.endOpenTime" type="date" class="date_picker" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
					</div>
					<div class="popover_col">
						<span class="popover_font">到期日期</span>
						<el-date-picker v-model="pickTime.startExpireTime" type="date" class="date_picker" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
						<span class="split-line"></span>
						<el-date-picker v-model="pickTime.endExpireTime" type="date" class="date_picker" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
					</div>
					<div class="popover_col">
						<span class="popover_font">续费日期</span>
						<el-date-picker v-model="pickTime.renewBeginTime" type="date" class="date_picker" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
						<span class="split-line"></span>
						<el-date-picker v-model="pickTime.renewEndTime" type="date" class="date_picker" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
					</div>
					<!-- <div class="popover_col">
              <span class="popover_font">续费日期</span>
              <el-date-picker
                v-model="pickTime.renewStartTime"
                type="date"
                class="date_picker"
                placeholder="请选择日期">
              </el-date-picker>
              <span class="split-line"></span>
              <el-date-picker
                v-model="pickTime.renewEndTime"
                type="date"
                class="date_picker"
                placeholder="请选择日期">
              </el-date-picker>
          </div>-->
					<span class="cus_btn cub_gray" slot="reference">
						日期筛选
						<i class="iconfont icon-more" style="font-size:12px"></i>
					</span>
				</el-popover>
				<div class="search_btn">
					<div @click="searchSim">查询</div>
				</div>
				<span class="tips">
					<div>应供应商要求：</div>
					&nbsp &nbsp&nbsp&nbsp 北京卡（新）在到期次月续费需收取1元保号费，到期次月的卡续费需先支付保号费。到期当月正常续费，第三个月默认注销。
				</span>
				<span class="price">
					虚拟币:
					<span>{{ totalCorn.corn }}</span>
				</span>
			</div>
			<div class="filter-table-wrap" ref="filter_table_wrap" :style="{ 'padding-top': isSelect == 1 ? '0' : '20px' }">
				<filter-type
					:isAll="isAll"
					:pickTime="pickTime"
					:total="total"
					@handleResult="handleResult"
					:selectCheck="isSelect"
					@outSim="handleOutSim"
					@searchResult="searchResult"
					:isUpdate="uploadFlag"
					@searchCommit="searchCommit"
					@duanxin="allSmsDialog()"
					@shuaxin="uploadSim"
					:grounpsTree="getTreeData || []"
					:selectArr="multipleSelection"
					:tableData="tableData"
					:isStatus="isStatus"
					ref="filterType"
					@isloadingTable="isloadingTable"
					:tableTotal="total"
					@remarkShow="remarkShow"
					@handleRefresh="handleRefresh"
          @handleRemark="onOpenRemark(null)"
					:card1Data="card1Data"
          @onMachineCard="onMachineCard"
				></filter-type>
				<div v-if="isSelect === 2" class="sell_export">
					<el-button type="primary" @click="handleChildrenAllocate" size="small">划 拨</el-button>
					<el-button type="primary" @click="handleSellExport" size="small">导 出</el-button>
				</div>
				<el-table
					:data="tableData"
					stripe
					empty-text="该批次无库存"
					@selection-change="handleSelectionChange"
					v-loading="loadingTable"
					style="width: 100%;border:1px solid #EBF0F6;"
					:height="isSelect == 1 ? tableHeight + 'px' : 'calc(100vh - 230px)'"
				>
					<el-table-column fixed="left" type="selection" width="55"></el-table-column>
					<el-table-column fixed="left" type="index" label="序号" width="55" />
					<el-table-column fixed="left" prop="simCard" align="center" label="SIM卡号" min-width="130"></el-table-column>

					<el-table-column fixed="left" prop="iccid" align="center" label="ICCID" min-width="200"></el-table-column>

					<el-table-column prop="userName" align="center" label="客户代码" min-width="120"></el-table-column>
          <el-table-column width="140" prop="surplusGprs" align="center" label="剩余用量">
						<template slot-scope="scope">
							<div>
								{{ formatterGprs(scope.row.surplusGprs) }}
								<br />
								{{ `${scope.row.cardSupplier == 10 ? `（${scope.row.surplusSecond}分钟）` : ''}` }}
							</div>
						</template>
					</el-table-column>
					<el-table-column width="100" prop="simType" align="center" :formatter="formatterType" label="套餐类型"></el-table-column>
					<el-table-column width="140" prop="traffic" align="center" label="总流量">
						<template slot-scope="scope">
							<div>
								{{ formatterGprs(scope.row.traffic) }}
								<br />
								{{ `${scope.row.cardSupplier == 10 ? `（${scope.row.totalSecond}分钟）` : ''}` }}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="cardSupplier" align="center" label="卡供应商" min-width="140">
						<template slot-scope="scope">
							<span v-if="scope.row.cardSupplier != null">
								{{ useCardSupplier(scope.row.cardSupplier) }}
							</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
          <el-table-column width="100" prop="simState" align="center" label="sim卡状态">
						<template slot-scope="scope">
							<my-badge :simState="scope.row.simState"></my-badge>
						</template>
					</el-table-column>
					<el-table-column width="140" prop="traffic" align="center" label="已使用流量" v-slot="{ row }">
						<span>
							{{ formatterGprs(row.traffic - row.surplusGprs) }}
							<br />
							{{ `${row.cardSupplier == 10 ? `（${row.totalSecond - row.surplusSecond}分钟）` : ''}` }}
						</span>
					</el-table-column>
					<el-table-column width="100" prop="surplusGprs" align="center" label="历史流量" v-slot="{ row }">
						<span
							@click="
								$refs.historySimRefs.simCard = row.simCard;
								$refs.historySimRefs.cardSupplier = row.cardSupplier;
								$refs.historySimRefs.iccid = row.iccid;
								$refs.historySimRefs.visible = true;
							"
							class="cus_btn"
							>详情</span
						>
					</el-table-column>
					<el-table-column prop="activationTime" align="center" label="	激活日期" width="120"></el-table-column>
          <el-table-column prop="expireTime" align="center" width="130" label="过期日期"></el-table-column>
					<el-table-column prop="traffic" width="120" align="center" label="	当月已发短信" :formatter="fotmatterSms"></el-table-column>
					<el-table-column prop="renewDate" align="center" label="续费时间" width="120"></el-table-column>
          <el-table-column prop="openTime" align="center" label="	开卡日期" width="120"></el-table-column>
					<el-table-column prop="remark" align="center" label="备注" width="120">
            <template slot-scope="scope">
              <div class="overflow" :title="scope.row.remark">{{ scope.row.remark }}</div>
            </template>
          </el-table-column>
					<el-table-column label="操作" fixed="right" width="300" v-if="isSelect == 1">
						<template slot-scope="scope">
							<div class="cus_box">
								<span class="cus_btn" @click="getIotLlcx(scope.row.iccid, scope.row)">刷新</span>
								<span class="cus_btn" @click="singelSmsDialog(scope.row, scope.$index)">短信</span>
								<span class="cus_btn" @click="handlerOrder(scope.row, 2)">保号</span>
								<span class="cus_btn" @click="_RemarkerDialog(scope.row, scope.$index)">备注</span>
								<span
									class="cus_btn"
									v-if="[1,7,8,9,12,13,14,15,18].includes(Number(scope.row.cardSupplier))"
									@click="handlerOrder(scope.row, 0)"
									>续费</span>
								<!-- scope.row.isRenew == 1 && ( -->
								<span class="cus_btn" @click="handlerOrder(scope.row, 1)">叠加包</span>
								<span class="cus_btn" @click="getDetail(scope.row, scope.$index)">详情</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					:current-page.sync="pageNumber"
					@size-change="sizeChange"
					:page-sizes="[50, 100, 200, 300]"
					:page-size.sync="pageSize"
					@current-change="currentChange"
					layout="total, sizes,prev, pager, next, jumper"
					:total="total"
				></el-pagination>
				<!-- 流量设置 -->
				<el-dialog title="流量设置" :visible.sync="batchForflow" width="320px">
					<div class="titleStyle">
						<span class="iconfont icon-wenhao wenhao" @mouseover="isShowHelpLL = true" @mouseout="isShowHelpLL = false"></span>
					</div>
					<div class="helpStyle2" v-show="isShowHelpLL">
						<div class="fontColor1 marginStyle">关停流量: 设置该值后，SIM卡的流量只要少于该流量就会自动关停。</div>
						<div class="fontColor1 marginStyle">预超流量: 设置该值后，剩余流量低于该值首页会有风控警报提醒。</div>
					</div>
					<div class="dialog-item">
						<div class="item-left">关停流量≤</div>
						<input type="text" v-model="overGprs" class="inputBg item-last item-right guanStyle" />
						<span>M</span>
					</div>
					<div class="dialog-item">
						<div class="item-left">预超流量≤</div>
						<input type="text" v-model="exceedGprs" class="inputBg item-last item-right" />
						<span>M</span>
					</div>
					<div class="dialog-btn noBorderRadius" @click="setGlobalRisk">保存</div>
				</el-dialog>
				<el-dialog title="详情" :visible.sync="dialoDetail" width="550px" class="dialog_detail">
					<div class="detail_row">
						<div class="detail_col" v-for="(item, index) in detailData" :key="index">
							<span class="detail_label">{{ index }}</span>
							<input type="text" class="detail_input" readonly :value="item" />
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="dialoDetail = false" size="small">确定</el-button>
					</span>
				</el-dialog>
			</div>
		</div>

		<!-- 短信下发 start -->
		<smsDialog ref="smsDialog"></smsDialog>
		<!-- 短信下发 end -->
		<!-- 历史流量 start -->
		<history-sim ref="historySimRefs" />
		<!-- 历史流量 end -->
		<!-- 子账号SIM卡划拨 start -->
		<childrenAllocate ref="childrenAllocateRefs" :grounpsTree="getTreeData" :sourceUserId="activeUser ? activeUser.userId : 0" :simCards="multipleSelection" @handleSuccess="handleSuccess" />
		<!-- 子账号SIM卡划拨 end -->
    <!-- 备注弹框 -->
    <AddRemark :visible.sync="addRemarkShow" :ids="remarkIds" />
    <!-- 机卡分离 -->
    <MachineCardSeparation 
      :visible.sync="machineCardSeparationShow"
      :info="activeRow"
    />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import filterType from './filterType';
import myTree from '@/components/myTree/';
import myBadge from '@/components/myBadge/';
import { handleTree, toTreeData } from '@/util/handTree';
import { getUserType, hasDot, FormTime } from '@/util/common';
import smsDialog from './smsDialog';
import historySim from './historySim.vue';
import childrenAllocate from './childrenAllocate.vue';
import AddRemark from './addRemark.vue';
import MachineCardSeparation from "@/components/machineCardSeparation/index.vue";


export default {
	name: 'sim',
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableHeight = this.$refs.sim_right.clientHeight - this.$refs.filterType.$el.clientHeight - 165;
			}, 200);
		});
	},
  methods: {
    // 打开机卡分离弹框
    onMachineCard (row) {
      this.activeRow = row;
      this.machineCardSeparationShow = true;
    },
    useCardSupplier(type){
      return {
        1:'北京移动',
        2:'江门移动',
        3:'重庆卡',
        4:'江西卡',
        5:'深圳卡',
        6:'谷米卡',
        7:'北京移动(新)',
        8:'北京移动(新)',
        9:'北京移动(新)',
        10:'北京移动语音卡',
        11:'深圳移动',
        12:'联通',
        13:'北京移动4G卡',
        14:'惠州联通',
        15:'陕西移动',
        16:'云杉卡',
        17:'齐犇卡',
        18:'北京移动4G卡',
      }[type];
    },
    // 备注
    onOpenRemark(row){
      if(row){
        this.remarkIds = row.simCard;
      }else{
        if(!this.multipleSelection.length) {
          return this.$message({
            type:'warning',
            message:'请选择sim卡'
          });
        }
        this.remarkIds = this.multipleSelection.map(item => item.simCard).join(',');
      }
      
      this.addRemarkShow = true;
    },
		//划拨子账号SIM卡成功回调
		handleSuccess(activeNode) {
			this.handleTreeTwoData(this.activeUser);
		},
		//划拨子账号下SIM卡
		handleChildrenAllocate() {
			this.$refs.childrenAllocateRefs.visible = true;
		},
		//导出已出售卡数据
		handleSellExport() {
			if (!this.tableData.length) return;
			const simVos = this.multipleSelection.map((item) => item.simCard);
			const url = `/exportExcel/exportSonUserSimCard.json?customCode=${this.activeUser.customCode}&userId=${simVos.length ? '' : this.activeUser.userId}&simCards=${simVos.join(',')}`;
			window.open(url);
		},
		//获取当前保卡费
		handleProtect(time) {
			time = time.substring(5, 7);
			const activeTime = new Date().Format('MM');
			const num = parseInt(activeTime) - parseInt(time);
			return `保卡费：${num}个虚拟币`;
		},
		//批量刷新
		async handleRefresh() {
			if (!this.multipleSelection.length) {
				this.$message({
					showClose: true,
					duration: 1000,
					type: 'warning',
					message: '请勾选卡数据',
				});
				return;
			}
			let iccids = this.multipleSelection.map((item) => item.iccid).join(',');
			this.isloadingTable = true;
			const { data } = await this.$API.getIotLlcxList({ iccids });
			if (data.code == 0) {
				data.data.map((item) => {
					this.tableData.map((val, index) => {
						item.iccid == val.iccid &&
							((this.tableData[index].expireTime = item.expireTime),
							(this.tableData[index].activationTime = item.activationTime),
							(this.tableData[index].openTime = item.openTime),
							(this.tableData[index].surplusGprs = item.surplusGprs),
							(this.tableData[index].traffic = item.traffic));
					});
				});
			}
			this.isloadingTable = false;
			this.$message({
				showClose: true,
				type: data.code == 0 ? 'success' : 'warning',
				message: data.code == 0 ? '刷新成功' : data.msg,
			});
		},
		//续费-叠加包
		handlerOrder(row, activeType) {
			//0续费 1叠加包 2保号
			if (activeType === 2) {
				if ([2,3,4,5,11].includes(row.cardSupplier)) return this.$message.warning('此卡不需交保号费');
			}
			let name = activeType === 1 ? 'handlerOverlay' : 'handlerOrderBox';
			this.$refs.filterType[name](activeType, true, row);
		},
		//流量转换
		formatterGprs(gprs) {
			if (!gprs) return '0kb';
			const flow = Math.abs(Number(gprs));
			const burden = Number(gprs) > 0;
			if (flow > 1024 * 1024) {
				let num = flow / (1024 * 1024);
				return `${burden ? '' : '-'}${hasDot(num)}G`;
			} else if (flow > 1024) {
				let num = flow / 1024;
				return `${burden ? '' : '-'}${hasDot(num)}M`;
			} else {
				return `${burden ? '' : '-'}${flow}kb`;
			}
		},
		isloadingTable(data) {
			this.loadingTable = data.onoff;
			if (data.data) {
				this.paramsData = data.data;
				this.getTableFn = 'getSimData';
			}
		},
		getUserType,
		async uploadSim() {
			if (this.uploadFlag || this.tableData.length == 0) return;
			this.uploadFlag = true;

			if (this.tableData.length !== 0) {
				let params = this.tableData.map((data) => data.iccid);
				this.$message('正在更新数据');
				let res = await this.$API.getIotLlcxAll({ iccid: params.join(',') });
				for (let i = 0; i < this.tableData.length; i++) {
					for (let j = 0; j < res.data.length; j++) {
						if (this.tableData[i].iccid === res.data[j].iccid) {
							this.tableData[i].traffic = res.data[j].traffic;
							this.tableData[i].surplusGprs = res.data[j].surplusGprs;
						}
					}
				}
				this.uploadFlag = false;
			}
			//
		},
		//查看详情
		getDetail(data) {
			this.detailData = {
				iccid: data.iccid,
				SIM卡号: data.simCard,
				库存状态: data.outOrIn === 0 ? '未出库' : '出库',
				SIM卡状态: this.fomatterSimstate(data.simState),
				总流量: this.formatterGprs(data.traffic),
				剩余流量: this.formatterGprs(data.surplusGprs),
				套餐类型: this.formatterType(data),
				开卡日期: data.openTime,
				激活日期: data.activationTime,
				过期时间: data.expireTime,
				价格: this.fotmatterPrice(data),
				当月短信: data.sms,
			};

			this.dialoDetail = true;
		},
		fomatterSimstate(simState) {
			if (simState !== undefined) {
				switch (simState) {
					case 0:
						return '正常';
					case 1:
						return '正常';
					case 2:
						return '过期';
					case 3:
						return '销卡';
				}
			}
		},
		_RemarkerDialog(row) {
			// 打开备注信息
			this.$refs.filterType.dialog.remark = true;
			this.$refs.filterType.row = row;
		},
		//显示备注
		remarkShow(data) {
			this.tableData = this.tableData.map((item) => {
				if (item.simCard == data.simCard) {
					item.remark = data.data;
				}
				return item;
			});
		},
		typeUpdate(data) {
			this.$refs.filterType.dialog.taocan = true;
			this.$refs.filterType.typeData = {
				changeType: data.simType,
				allIccid: data.iccid,
			};
		},
		async handleOutSim(len) {
			let allIccid = '';
			this.multipleSelection.map((item) => {
				allIccid += item.iccid + ',';
			});
			try {
				let data = await this.$API.restockUserSim({ allIccid });
				this.multipleSelection.map((data) => {
					this.tableData.map((item, index) => {
						if (item.iccid == data.iccid) {
							this.tableData.splice(index, 1);
						}
					});
				});

				this.$message({
					message: '退卡成功',
					type: 'success',
				});
			} catch (error) {
				this.$message({
					message: '退卡失败',
					type: 'warning',
				});
			}
		},
		//点击刷新
		async getIotLlcx(iccid, row) {
			this.loadingTable = true;
			await this.$API
				.getIotLlcx({ iccid })
				.then((res) => {
					for (let i in this.tableData) {
						if (iccid === this.tableData[i].iccid) {
							if (res.data) {
								res.data.activationTime = res.data.activationTime ? res.data.activationTime : this.tableData[i].activationTime;
								res.data.expireTime = res.data.expireTime ? res.data.expireTime : this.tableData[i].expireTime;
								res.data.openTime = res.data.openTime ? res.data.openTime : this.tableData[i].openTime;
								this.tableData[i] = Object.assign(this.tableData[i], res.data);
							}
							break;
						}
					}
					this.$message({
						message: res.msg,
						type: 'success',
					});
					this.loadingTable = false;
				})
				.catch((error) => {
					this.loadingTable = false;
				});
		},
		//短信
		singelSmsDialog(row, index) {
			this.$refs.smsDialog.row = row;
			this.$refs.smsDialog.isSingle = true;
			this.$refs.smsDialog.visible = true;
		},
		allSmsDialog() {
			if (!this.multipleSelection.length) {
				this.$message({
					message: '请选择SIM卡！',
					type: 'warning',
				});
				return;
			}
			// this.$refs.smsDialog.selectArr = JSON.parse(
			//   JSON.stringify(this.multipleSelection)
			// );
			let jsonData = Object.assign(
				{},
				{
					...this.$refs.filterType.searchSimListParams,
					...this.$refs.filterType.searchSimListByInventoryParams,
				},
			);
			jsonData.pageSize = this.pageSize;

			// this.$API
			// 	.searchSimListByInventory(jsonData)
			// 	.then((res) => {
					// this.multipleSelection = [];
					// if (res.code == 0) {
						this.$refs.smsDialog.selectArr = [...this.multipleSelection];
						this.$refs.smsDialog.activeIndex = 0;
						this.$refs.smsDialog.row = this.$refs.smsDialog.selectArr[0];
						this.$refs.smsDialog.isSingle = false;
						this.$refs.smsDialog.visible = true;
				// 	}
				// })
				// .catch((error) => {
				// 	console.log(error);
				// });
		},
		fotmatterPrice(row) {
			return row.prices ? '¥' + row.prices : '¥' + 0;
		},
		fotmatterSms(row) {
			return row.sms + '条';
		},
		fotmatterSim(row) {
			return row.traffic + '/kb';
		},
		searchResult(res) {
			this.pageNumber = 1;
			this.tableData = res.data;
			this.total = res.total;
			this.loadingTable = false;
		},
		searchSim() {
			this.loadingTable = true;
			this.pageNumber = 1;
			this.simprops.simCards = this.simprops.simCards.split(/[\n\s+,]/g).join(',');
			let params = Object.assign(this.simprops, this.pickTime);
			//if(this.isStatus){
			params.pageSize = this.pageSize;
			params.pageNumber = this.pageNumber;
			//}
			this.$refs.filterType.searchSimList(params);
			this.multipleSelection = [];
		},
		// 过滤套餐类型
		formatterType(row) {
			return row.simType / 1024 >= 1 ? parseInt(row.simType / 1024) + 'G' : row.simType + 'M';
		},
		formatterTabel(row, column) {
			return ['正常', '正常', '过期', '销卡'][row.simState];
		},
		formatterTraffic(row) {
			return row.traffic + '/kb';
		},
		formatterSurplusGprs(row) {
			if (!row.surplusGprs) return '0kb';
			return row.surplusGprs + 'kb';
		},
		handleSelectionChange(val) {
			this.isAll = val.length == this.pageSize ? true : false;
			this.multipleSelection = val;
      console.log(val);
		},
		//  1.是否是单条数据更新  2.剩下未出库的数据  3.转入的卡组ID 4.上级gounpID
		handleResult(data, selectData, gid, selfgid) {
			// 如果有的话ICCID  则是单条数据更新
			let islen = typeof selectData == 'number' ? true : false;
			let len = islen ? selectData : selectData.length;
			if (data) {
				len = 1;
				this.tableData[this.rowIndex].outOrIn = len;
			} else {
				if (islen) {
					this.tableData.map((item) => {
						item.outOrIn = 1;
					});
				} else {
					selectData.map((item) => {
						item.outOrIn = 1;
					});
				}
			}
			this.upDateZn(len, selfgid);
			if (gid) {
				this.upDateTree(this.grounpsTree[0].children, gid, len);
			}
		},
		upDateZn(count, grounp) {
			this.selectOneTree[0].children[0].children.map((item) => {
				if (item.groupId == grounp) {
					item.name = `${item.pid}-${item.id} (${(item.kucun -= count)} / ${item.innum})`;
				}
			});
		},
		upDateTree(tree, gid, num, label = 'name') {
			for (let i = 0; i < tree.length; i++) {
				if (tree[i].groupId == gid) {
					let splData = tree[i][label].split('(');
					let gn = splData[0];
					let oldNum = parseInt(splData[1].slice(0, -1));
					tree[i][label] = `${gn} (${oldNum + num})`;
				}
			}
		},
		huabo(data, index) {
			//有groupId为单条数据
			let arr = '';
			this.rowIndex = index;
			this.$refs.filterType.iccid = data.iccid;
			this.$refs.filterType.parentId = data.inventoryTime;
			this.$refs.filterType.dialog.huabo = true;
		},
		//1 库存 2为处理出售   -----点击我的库存与我的卡
		handleNodeClick(data) {
			console.log(data,'data');
			//判断是否进入我的卡
			this.activeUser = data;
			this.isStatus = data.type;
			if (data.type) {
				this.activeData = data.type;
				this.pageNumber = 1;
				this.tableData = [];
				data.params = {};
				this.paramsData = {
					endTime: '',
					pageNumber: this.pageNumber,
					pageSize: this.pageSize,
					searchType: '',
					startTime: '',
				};
				data.params = { ...this.paramsData };
				this.getTableFn = 'getSimData';
				this.handleTreeOneData(data);
			} else {
				this.tableData = [];
				this.activeData = false;
				this.pageNumber = 1;
				if (data.isparent) return;
				if (this.isSelect === 1) {
					this.isGrounps = false;
					this.handleTreeOneData(data);
				} else {
					this.isGrounps = true;
					this.handleTreeTwoData(data);
				}
			}
		},
		async handlegroupClcik(data) {
			if (data.groupId) {
				this.$refs.filterType.parentId = data.groupId;
				this.$refs.filterType.searchSimListByInventoryParams = null;
				let params = {
					groups: data.groupId,
					pageSize: this.pageSize,
					pageNumber: this.pageNumber,
				};
				this.paramsData = params;
				this.getTableFn = 'getGrounpData';
				this.getGrounpData(params);
			}
		},
		async getGrounpData(params) {
			try {
				let res = await this.$API.searchSimListByGroups(params);
				this.tableData = res.data;
				this.loadingTable = false;
				this.isGrounps = true;
				this.total = res.total;
			} catch (error) {
				this.loadingTable = false;
				console.error('错误信息:', error);
			}
		},
		getLastDayOfMonth(year, month) {
			return new Date(year, month, 0).Format('dd');
		},
 
		//点击侧边栏查询数据
		handleTreeOneData(data) {
			// if (!data.id || data.name === "我的库存" ) {
			//   return;
			// }
			let params = {};
			data.children = data.children || [];
			// if (data.children.langth == 0 || data.params) {
			if (data.id == -2) {
				this.getSimData(data.params);
				return;
			} else {
				// this.$refs.filterType.parentId = data;
				this.$refs.filterType.parentId = data.groupId;
				this.$refs.filterType.activeType.type = '';
				console.log(data, 'data');
				let startTime = '';
				let endTime = '';
        console.log(data.dateType)
        if(data.dateType === 'year'){
          startTime = `${data.params}-01-01 00:00:00`;
					endTime = `${data.params}-12-${this.getLastDayOfMonth(data.params, 12)} 23:59:59`;
        }else if(data.dateType === 'month'){
          const [year, month] = data.params.split('-');
          startTime = `${data.params}-01 00:00:00`;
					endTime = `${data.params}-${this.getLastDayOfMonth(year, month)} 23:59:59`;
        }else{
          startTime = `${data.params} 00:00:00`;
					endTime = `${data.params} 23:59:59`;
        }
				params = {
					startTime,
					endTime,
					pageSize: this.pageSize,
					pageNumber: this.pageNumber,
				};
				this.$refs.filterType.searchSimListByGroupsParams = null;
				this.$refs.filterType.exportParams = null;
				this.$refs.filterType.searchSimListByInventoryParams = params;
				this.$refs.filterType.outcount = data.innum - data.outnum;
				params.searchType = '';

				this.getSimData(params);
			}
		},
		handleTreeTwoData(data) {
			if (data.simNum) {
				this.handlegroupClcik(data);
				return;
			}
			this.getUserData({ userId: data.userId });
		},
		getUserData(params) {
			this.loadingTable = true;
			this.paramsData = params;
			// params.pageSize = 50;
			this.getTableFn = 'getUserData';
			this.$API
				.sellSimList(params)
				.then((res) => {
					this.tableData = res.data;
					this.total = res.total;
					// this.$message({
					//   message: "查询成功",
					//   type: "success"
					// });
					this.loadingTable = false;
				})
				.catch((error) => {
					console.error('错误信息:', error);
					this.loadingTable = false;
				});
		},
		getSimData(params) {
			this.loadingTable = true;
			this.paramsData = params;
			this.getTableFn = 'getSimData';
			let apiName = this.isStatus ? 'searchAllSimListByInventory' : 'searchSimListByInventory';
			this.$API[apiName](params)
				.then((res) => {
					this.tableData = res.data;
					this.total = res.total;
					this.loadingTable = false;
					this.$refs.filterType.setTransferData(params);
				})
				.catch((err) => {
					this.loadingTable = false;
				});
		},
		clearData() {
			for (var i in this.simprops) {
				this.simprops[i] = '';
			}
		},
		searchCommit(val) {
			this.getSimData({
				simCards: val,
				pageSize: this.pageSize,
				pageNumber: this.pageNumber,
			});
		},
		async loadGroupsData() {
			let res = await this.$API.loadInventoryData();

			let InNum = 0;
			let OutNum = 0;
			res.data.map((item) => {
				item.outnum += item.outNum;
				InNum += parseInt(item.totalNum);
				OutNum += parseInt(item.outNum);
			});
			this.selectbtnText[0] = `库存(${this.totalNum})`;
			let treeData = toTreeData(res.data);
			this.selectOneTree = [
				{
					name: '我的库存',
					img: '/other/kucun.png',
					children: treeData,
					id: -1,
				},
				{
					name: '我的卡',
					img: '/other/kucun.png',
					children: [],
					id: -2,
					type: true,
				},
			];
			this.treeData = this.selectOneTree;
			this.loadcustomerData(OutNum);
		},
		async loadcustomerData(OutNum) {
			let res = await this.$API.loadGroupsData();
			let pNum = OutNum;
			res.data.map((item) => {
				item.groupName += ` (${item.simNum})`;
				item.name = item.groupName;
				item.icon = 'icon-pinglunbankexingxing-copy';
				pNum -= item.simNum;
			});
			this.$set(this.selectbtnText, 1, `已出售`);
			this.grounpsTree = [
				{
					name: '我的卡组',
					img: '/other/cards.png',
					plus: true,
					children: res.data,
					isparent: true,
				},
			];
		},
		currentChange(page) {
			this.pageNumber = page;
			this.paramsData = Object.assign(this.paramsData, { pageNumber: page, pageSize: this.pageSize });
			this[this.getTableFn](this.paramsData);
		},
		sizeChange(page) {
			this.pageSize = page;
			this.paramsData = Object.assign(this.paramsData, { pageSize: page, pageNumber: this.pageNumber });
			this[this.getTableFn](this.paramsData);
		},
		selectClick(select) {
			this.isSelect = select;
			this.multipleSelection = [];
			if (this.isSelect == 2) {
				this.treeData = this.getTreeData;
			} else {
				this.treeData = this.selectOneTree;
			}
			this.total = 0;
			this.tableData = [];
		},
		pushTree(treeData) {
			this.$prompt('请输入卡组名称', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValidator: (val) => {
					return val.length > 12 ? false : true;
				},
				inputErrorMessage: '不能超过12位',
			})
				.then(async ({ value }) => {
					let params = {
						parentId: -1,
						groupName: value,
						userId: this.$store.state.LOGINUSER.id,
					};
					let data = await this.$API.addSimGroup(params);
					this.addTree(treeData, data.data.data);
					this.$message({
						type: 'success',
						message: '添加成功',
					});
				})
				.catch(() => {});
		},
		addTree(treeData, data) {
			const newChild = {
				groupId: data.groupId,
				name: data.groupName + ' (0)',
				icon: 'icon-pinglunbankexingxing-copy',
			};
			if (!this.grounpsTree[0].children) {
				this.$set(this.grounpsTree[0], 'children', []);
			}
			this.grounpsTree[0].children.push(newChild);
		},
		async setGlobalRisk() {
			let simType = this.riskParams.simType;
			return false;
		},
		async getUser() {
			var user = await this.$API.getNextUserInfo({
				userId: this.$store.state.LOGINUSER.id,
			});
			return user.data;
		},
	},

	created() {
		this.card1Data = this.$route.params.key;
		this.loadGroupsData();
	},
	data() {
    return {
      /** 机卡分离弹框 */
      machineCardSeparationShow: false,
      activeRow:null,
      remarkIds:'',
      addRemarkShow:false,
			activeUser: null,
			iccid: '',
			card1Data: '', //首页card1 goClick编程式导航传过来的params
			tableHeight: 400,
			isAll: false,
			isStatus: false,
			paramsData: null,
			activeData: false,
			isShowHelpLL: false,
			uploadFlag: false, // 是否刷新完成
			pickTime: {
				startOpenTime: '', //开卡日期 Start
				endOpenTime: '', // 开卡日期 End
				startExpireTime: '', //到期日期 Start
				endExpireTime: '', // 到期日期 End
				renewBeginTime: '', //续费日期 Start
				renewEndTime: '', // 续费日期 End
			},
			rowIndex: 0,
			dialoDetail: false,
			getTableFn: '', // 分页请求的方法
			isGrounps: false,
			loadingTable: false,
			detailData: {},
			selectNum: 1,
			selectOneTree: [],
			selectbtnText: ['库存', '已出售'], // 库存数量
			grounpProps: {
				children: 'children',
				label: 'groupName',
			},
			simprops: {
				simCards: '',
				startIccid: '', //开始iccid号	string
				endIccid: '', //结束iccid号	string
				startSimCard: '', //开始sim号	string
				endSimCard: '', //结束sim号	string
			},
			riskParams: {
				exceedGprs: '',
				overGprs: '',
				simType: '请选择套餐类型',
				riskType: 2,
			},
			batchForflow: false,
			filterText: '',
			isSelect: 1,
			grounpsTree: null,
			gid: '',
			treeData: [],
			defaultProps: {
				children: 'children',
				label: 'name',
			},
			tableData: [], // 表格数据
			pageNumber: 1,
			pageSize: 50,
			total: 0,
			multipleSelection: [],
			statusType: {
				options: [
					{
						value: '选项1',
						label: '全部状态',
					},
					{
						value: '选项2',
						label: '沉默',
					},
					{
						value: '选项3',
						label: '激活',
					},
				],
				value: '选项1',
			},
		};
	},

	components: {
		historySim,
		filterType,
		myTree,
		myBadge,
		smsDialog,
		childrenAllocate,
    AddRemark,
    MachineCardSeparation
	},
	computed: {
		...mapState(['totalNum']),
		isDateLast() {
			let MM = parseInt(new Date().Format('MM')) + 1;
			let time = new Date(new Date().Format(`${MM < 10 ? `0${MM}` : MM}-01`)).getTime() - 86400000;
			return FormTime(time).substring(3);
		},
		totalCorn() {
			return this.$store.state.totalCorn;
		},
		getTreeData() {
			let data = [];
			if (this.getUserList.length) {
				data = this.getUserList.map((item) => {
					return { ...item, name: item.userName };
				});
			}
			return [
				{
					name: '我的客户',
					img: '/other/kehu.png',
					children: data,
					isparent: true,
				},
				this.grounpsTree ? this.grounpsTree[0] : [],
			];
		},

		simList() {
			return this.$store.state.simList;
		},
		getUserList() {
			return this.$store.state.userList.length ? this.$store.state.userList : this.getUser();
		},
		exceedGprs: {
			set: function(value) {
				this.riskParams.exceedGprs = value;
			},
			get: function() {
				return this.riskParams.exceedGprs == '' ? '1' : this.riskParams.exceedGprs.replace(/[^0-9]+/g, '');
			},
		},
		overGprs: {
			set: function(value) {
				this.riskParams.overGprs = value;
			},
			get: function() {
				return this.riskParams.overGprs == '' ? '1' : this.riskParams.overGprs.replace(/[^0-9]+/g, '');
			},
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/public/css/base.scss';
@import '@/public/css/mixin.scss';
.sim {
	display: flex;
	overflow: hidden;
	position: absolute;
	left: 20px;
	right: 20px;
	top: 20px;
	bottom: 20px;
	.sell_export {
		margin-bottom: 20px;
		text-align: right;
	}
	.dialog_detail {
		& /deep/ .el-dialog__body {
			padding: 30px 30px 5px;
		}
		.detail_row {
			display: flex;
			flex-wrap: wrap;
			.detail_col {
				margin-bottom: 20px;

				&:nth-child(even) {
					margin-left: auto;
				}
				.detail_input {
					@extend .inputBg;
					width: 140px;
				}
				.detail_label {
					display: inline-block;
					font-size: 12px;
					font-family: PingFang-SC-Bold;
					font-weight: bold;
					color: rgba(88, 97, 108, 1);
					width: 80px;
				}
			}
		}
	}
	.price {
		position: absolute;
		right: 20px;
		top: 36px;
		> span {
			color: #eb5b5b;
		}
	}
	.sim-left {
		width: 230px;
		position: relative;
		margin-right: 10px;
		display: flex;
		flex-direction: column;
		#simTop {
			height: 100%;
		}
		.sim-left-top {
			height: 100%;
			// padding: 0 20px 20px;
			background: #fff;
			overflow: hidden;
		}
		.sim-left-footer {
			height: 50%;
			padding: 20px;
			background: #fff;
			margin-top: 20px;
			overflow: hidden;
			& /deep/ .selecttree {
				height: 100%;
			}
		}
	}
	.sim-right {
		// background: #fff;
		flex: 1;
		min-width: 900px;
		position: relative;
		.search_tableBox {
			// height: 90px;
			background: #fff;
			box-sizing: border-box;
			margin-bottom: 10px;
			padding: 15px 0;
			display: flex;
			.search_sim {
				display: flex;
				width: 460px;
				align-items: center;
				.filter-type-input {
					background: #edf2f8;
					color: #828588;
					border: none;
					outline: 0;
					padding: 0 15px;
					height: 32px;
				}
			}
			.cub_gray {
				color: #58616c;
				line-height: 55px;
				margin: 0 10px;
				display: inline;
			}
			.search_btn {
				width: 8%;
				justify-content: center;
				display: flex;
				align-items: center;
				div {
					width: 70%;
					line-height: 27px;
					font-size: 13px;
					height: 27px;
					@include btn1;
				}
			}
			.search_text {
				// flex: 1;
				width: 460px;
				overflow: hidden;
				textarea {
					// width: 500px;
					height: 100%;
				}
			}
			.search_tab {
				display: flex;
				width: 10%;
				height: 55px;
				justify-content: center;
				.el-radio-group {
					display: flex;
					flex-direction: column;
					& /deep/ .el-radio__label {
						font-size: 12px;
					}
					.el-radio + .el-radio {
						margin-left: 0;
						margin-top: auto;
					}
				}
			}
		}
		.filter-table-wrap {
			// border: 1px solid #ebf0f6;
			// position: absolute;
			padding: 0 20px;
			background: #fff;
			// top: 84px;
			// left: 20px;
			// right: 20px;
			// bottom: 20px;
		}
	}
	.dialog-item {
		display: flex;
		align-items: center;
		margin: 0 0 25px 0px;
		// &:nth-child(3) {
		//   .item-right {
		//     margin-right: 10px;
		//     width: 150px;
		//   }
		// }
		.item-last {
			margin-right: 10px;
			width: 150px !important;
		}
		&:first-child {
			margin: 0 0 20px 0;
			// padding: 20px 0;
			.item-right {
				font-weight: Bold;
				color: #1c5ed6;
			}
		}
		.item-left {
			width: 80px;
			.el-radio__label {
				font-size: 12px;
			}
		}
		.item-right {
			margin-left: 10px;
			width: 160px;

			.select {
				height: 30px;
				line-height: 30px;
				width: 150px;
				color: #bdc6d0;
			}
			.el-date-editor.el-input {
				width: auto;
			}
			.el-input__inner {
				padding-left: 30px;
				height: 30px;
				width: 160px;
				border-radius: 0;
				@extend .inputBg;
			}
			.el-input__icon {
				line-height: 30px;
			}
		}
	}
	.dialog-btn {
		width: 90px;
		cursor: pointer;
		height: 30px;
		background: #1c5ed6;
		border-radius: 3px;
		line-height: 30px;
		margin: 20px auto;
		color: #fff;
		text-align: center;
	}
	.guanStyle {
		color: #000 !important;
		font-weight: normal !important;
	}
	.noBorderRadius {
		border-radius: 0;
	}
	/deep/ .el-dialog__title {
		color: #4b88f6;
		font-size: 14px;
		font-weight: bold;
	}
	.titleStyle {
		position: relative;
		top: -61px;
		left: 60px;
		width: 190px;
	}
	.wenhao {
		color: #9ba3ab;
	}
	.helpStyle2 {
		position: absolute;
		top: 40px;
		left: 80px;
		background: #f2f9ff;
		width: 390px;
	}
	.fontColor1 {
		color: #818ea5;
		font-size: 12px;
	}
	.marginStyle {
		margin: 10px;
	}
}
.tips {
	width: 30%;
	color: red;
}
.overflow{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
